<template>
  <ux-form
    class="instructions"
    ref="form"
    :data="formData"
    width="500px"
    :colon="true"
    :rules="rules"
    label-width="56px"
    data-automation="instructions"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.file')" required start prop="list">
      <ux-upload v-model="formData.list" :acceptTip="$t('HT.importOrder.acceptTip')"></ux-upload>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          list: []
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addGroup()
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$emit('confirm', this.formData);
    }
  }
};
</script>
